
  export default {
    // ensure that window.Nuxt is instantiated
    beforeCreate() {
      if (process.client && window.__NUXT__ === undefined) {
        window.__NUXT__ = { fetch: {} }
      }
    },
  }
